export class ParamsUtils {
    /**
     * Generate params map for cid
     * @param {string} cid
     * @return {Map<string, string>}
     */
    public static cidMap(cid: string): Map<string, string> {
        const cidMap: Map<string, string> = new Map<string, string>();
        if (cid) {
            cidMap.set('{{cid}}', cid);
        }
        return cidMap;
    }
}
